import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    to: _ctx.isRouterLink ? _ctx.to : undefined,
    href: _ctx.isAnchor ? _ctx.href : undefined,
    type: _ctx.isButton ? _ctx.type : undefined,
    tabindex: _ctx.isDisabled ? -1 : _ctx.tabIndex,
    class: _normalizeClass(_ctx.buttonClasses),
    "aria-disabled": _ctx.isDisabled ? 'true' : undefined,
    onClick: _ctx.handleClick
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("טוען...")
          ], 64))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["to", "href", "type", "tabindex", "class", "aria-disabled", "onClick"]))
}